import { doLogin, getAjefUserDetails } from '@/api/api'
import { clearAuthStorage, getToken, getUserInfo, setToken, setUserInfo } from '@/utils/auth'

const state = {
  token: getToken() || '',
  userInfo: getUserInfo() || null
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token || ''
  },
  SET_USER_INFO (state, userInfo) {
    state.userInfo = userInfo || null
  }
}

const actions = {
  async login ({ commit }, form) {
    const res = await doLogin(form)
    const userInfo = res.data || {}
    const token = userInfo.useref || ''
    setToken(token)
    setUserInfo(userInfo)
    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
    return userInfo
  },
  // 登录后通过 auId 获取最新用户详情
  async refreshUserInfo ({ commit, state }) {
    if (!state.token) return null
    const cached = getUserInfo() || {}
    const auId = cached.auId
    if (!auId) return cached
    const res = await getAjefUserDetails({ auId })
    const userInfo = res.data || {}
    setUserInfo(userInfo)
    commit('SET_USER_INFO', userInfo)
    return userInfo
  },
  logout ({ commit }) {
    clearAuthStorage()
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
